import React from "react";
import { SectionCta } from "../SectionCta";
export function RealProblem() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-258" data-mp="5t2dndn66cuc">
      <div className="mx-auto max-w-3xl" data-id="element-259" data-mp="5uvl2v5lx13e">
        <h2 className="text-center font-display text-[32px] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-260" data-mp="t699dak8je9">
          The Real Problem Isn’t Always <span className="text-cta" data-id="element-261" data-mp="3szl7b0eivdhw">Your Knowledge.</span>
        </h2>
        <p className="mt-6 text-center font-display text-xl font-bold leading-snug text-brand sm:text-2xl" data-id="element-262" data-mp="th22g80x7t6a">
          Sometimes, the problem is having too much information without a clear framework for putting it together.
        </p>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink/85 sm:text-xl" data-id="element-263" data-mp="jq7cotogubg3">
          <p data-id="element-264" data-mp="fovuvabu2uig">
            You can spend years studying anatomy, orthopedic tests, biomechanics, and rehabilitation techniques.
          </p>
          <p data-id="element-265" data-mp="17hmiwxjd5cwm">
            But knowing individual techniques is not the same as having a structured process for deciding{" "}
            <strong className="text-ink" data-id="element-266" data-mp="36ddg7ctf0u1e">what information to collect, how to interpret your findings, and when a patient may need further medical evaluation.</strong>
          </p>
          <p data-id="element-267" data-mp="2wn0ydsczjeyy">That is the gap I wanted to address when developing the Musculoskeletal Clinical Pathway™.</p>
          <p data-id="element-268" data-mp="31kaj4upfj2gg">
            I designed it to help you bring the pieces together in a practical, organized format you can revisit whenever
            you need to review your assessment process.
          </p>
        </div>

        <SectionCta label="Close the Gap in My Assessments" data-id="element-269" data-mp="2sm8oqy07b825" />
      </div>
    </section>;
}